import { PropsWithChildren } from "react";

import CreateHeadlineForm from "../create-headline/CreateHeadlineForm";
import {
  CloseButton,
  Dialog,
  DialogBackdrop,
  DialogPanel,
} from "@headlessui/react";
import { Button } from "@/ui-components/button-with-loading";
import { XMarkIcon } from "@heroicons/react/24/outline";
import Spinner from "@/ui-components/spinner";

import { Headline } from "./models/Headline";
import { useHeadlineById } from "@/shared/api/newsquawk-headlines";

type PropsTypes = {
  headline: Headline | null;
  onClose: () => void;

  isOpen: boolean;
} & PropsWithChildren;

function EditHeadlineFormDialog(props: PropsTypes) {
  /** Since there are inconsistencies in the REST, SSE and Search endpoints,
   * we need to fetch the headline from the server
   * and populate edit form with the data
   */
  const { data: headline, isLoading } = useHeadlineById(
    props.headline?.id || null
  );

  return (
    <Dialog
      open={props.isOpen}
      onClose={props.onClose}
      className="no-drag relative z-10"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-900/90 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto pt-16 md:pt-8">
        <div className="flex min-h-full items-end justify-center p-4 text-center  sm:items-center sm:p-0 ">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-gray-800 px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full md:max-w-screen-md sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <CloseButton
              as={Button}
              variant="secondary"
              className={"absolute right-2 top-2 sm:block"}
              renderIcon={() => <XMarkIcon className="size-5 font-medium" />}
            >
              <span className="sr-only">Close</span>
            </CloseButton>

            <div>
              {headline && !isLoading ? (
                <CreateHeadlineForm
                  mode="edit"
                  headline={headline}
                  onSubmitted={props.onClose}
                />
              ) : (
                <div className="h-[200px] flex justify-center items-center">
                  <Spinner size="lg" />
                </div>
              )}
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}

export default EditHeadlineFormDialog;
